if (window.Shopify && Shopify.designMode) {
  document.documentElement.classList.add('shopify-design-mode');
}
(function () {
  var data = document.getElementById('theme-globals-data');
  if (!data) return;
  var g = JSON.parse(data.textContent);
  window.shopUrl = g.shopUrl;
  window.routes = g.routes;
  window.cartStrings = g.cartStrings;
  window.variantStrings = g.variantStrings;
  window.quickOrderListStrings = g.quickOrderListStrings;
  window.accessibilityStrings = g.accessibilityStrings;
})();

// Apply deferred stylesheets (replaces the old inline onload="this.media='all'")
document.querySelectorAll('link[data-defer-css]').forEach(function (link) {
  if (link.sheet) {
    // Already finished downloading before this script ran → apply it now
    link.media = 'all';
  } else {
    // Still downloading → apply the moment it finishes
    link.addEventListener('load', function () {
      this.media = 'all';
    }, { once: true });
  }
});